import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import './index.css';

// Disable browser's automatic scroll restoration
// This prevents the browser from saving scroll position and restoring it on refresh
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Fix viewport height jumping in mobile browsers (Instagram, etc.)
// Lock to INITIAL viewport height (when address bar is visible) and NEVER change it
// This prevents elements from growing/shrinking when address bar shows/hides
let lockedViewportHeight: number | null = null;

const lockViewportHeight = () => {
  // Only set once - use the INITIAL viewport height (smallest, when address bar visible)
  if (lockedViewportHeight === null) {
    lockedViewportHeight = window.innerHeight;
    const vh = lockedViewportHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vh-px', `${lockedViewportHeight}px`);
  }
};

// Lock height immediately on load (before any scrolling)
lockViewportHeight();

// Only update on actual resize (not scroll) - and reset the lock
let resizeTimeout: number | null = null;
window.addEventListener('resize', () => {
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }
  resizeTimeout = window.setTimeout(() => {
    // Only reset if it's a significant change (orientation change, window resize)
    const currentHeight = window.innerHeight;
    if (lockedViewportHeight && Math.abs(currentHeight - lockedViewportHeight) > 100) {
      lockedViewportHeight = null; // Reset lock on major resize
      lockViewportHeight();
    }
  }, 300);
});

// Reset lock on orientation change
window.addEventListener('orientationchange', () => {
  lockedViewportHeight = null;
  setTimeout(lockViewportHeight, 100);
});

import { ThemeProvider } from './context/ThemeContext';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <Analytics />
    </ThemeProvider>
  </React.StrictMode>
);







